module.exports = __webpack_public_path__ + "img/print.168c7b41.png";